import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { classNames, useUitkContext, analyticsTracker } from 'uitk-react-utils';
import { UitkLinkAligns, UitkLinkThemes, UitkLinkSizes } from './types.esm.js';
import styles from './uitk-link.css';

var getClassNameList = classNames.bind(styles);
var UitkLink = function (props) {
    var _a, _b;
    var children = props.children, className = props.className, _c = props.align, align = _c === void 0 ? UitkLinkAligns.get('left') : _c, _d = props.theme, theme = _d === void 0 ? UitkLinkThemes.get('default') : _d, _e = props.inline, inline = _e === void 0 ? false : _e, _f = props.noWrap, noWrap = _f === void 0 ? false : _f, analytics = props.analytics, _g = props.size, size = _g === void 0 ? UitkLinkSizes.get('medium') : _g, disabled = props.disabled, domRef = props.domRef, attributes = __rest(props, ["children", "className", "align", "theme", "inline", "noWrap", "analytics", "size", "disabled", "domRef"]);
    var contextData = useUitkContext().data;
    var contextClassNames = (contextData !== null && contextData !== void 0 ? contextData : {}).contextClassNames;
    var childrenArray = React.Children.toArray(children);
    var firstChild = childrenArray[0];
    var childClassName = getClassNameList('uitk-link', contextClassNames === null || contextClassNames === void 0 ? void 0 : contextClassNames.UitkLink, className, (_a = {},
        _a["uitk-link-align-".concat(align)] = align,
        _a['uitk-link-theme-inverse'] = theme === 'inverse',
        _a['uitk-link-no-wrap'] = noWrap,
        _a['uitk-link-layout-inline'] = inline,
        _a['uitk-link-layout-default'] = !inline,
        _a["uitk-link-".concat(size)] = size && UitkLinkSizes.get(size),
        _a['uitk-link-disabled'] = !!disabled,
        _a));
    var linkChildren = firstChild.props.children;
    var linkIconClassName = getClassNameList("uitk-link-icon-".concat(size), (_b = {},
        _b['uitk-link-inverse-icon'] = theme === 'inverse',
        _b));
    var newChildren = [];
    var isButton = (firstChild === null || firstChild === void 0 ? void 0 : firstChild.type) === 'button';
    var disabledButton = disabled && isButton;
    React.Children.map(linkChildren, function (child) {
        var _a;
        if (((_a = child === null || child === void 0 ? void 0 : child.type) === null || _a === void 0 ? void 0 : _a.displayName) === 'UitkIcon') {
            newChildren.push(React.cloneElement(child, {
                className: getClassNameList(linkIconClassName)
            }));
        }
        else {
            newChildren.push(child);
        }
    });
    var clickCaptureCallback = React.useCallback(function () {
        if (analytics) {
            return analyticsTracker(analytics);
        }
    }, [analytics]);
    var onClickCapture = firstChild.props.onClickCapture || props.onClickCapture || clickCaptureCallback;
    var decoratedChild = React.cloneElement(firstChild, __assign(__assign(__assign(__assign({ analytics: analytics, children: newChildren, ref: domRef, className: childClassName }, attributes), { onClickCapture: onClickCapture }), (disabledButton && {
        tabIndex: -1,
        disabled: true
    })), (!isButton && {
        role: 'link',
        'aria-disabled': disabled || undefined // 'undefined' fixes cursor bug
    })));
    return decoratedChild;
};
UitkLink.displayName = 'UitkLink';

export { UitkLink };
